"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M12.126 11.896H2c-.048 4.323 2.731 8.34 7.075 9.668.43.132.86.23 1.292.302l1.758-9.97z" }),
    React.createElement("path", { d: "M16.512 11.896l.649-3.68h4.093a9.98 9.98 0 00-6.331-5.777C9.937.915 4.678 3.48 2.747 8.216h13.765l-2.39 13.557a9.993 9.993 0 007.44-6.848 9.983 9.983 0 00.438-3.03l-5.488.001z" })), "Twinmotion");
//# sourceMappingURL=Twinmotion.js.map